import { useQuery } from "@tanstack/react-query";
import { CountryCode, TrainIdentifier } from "@vygruppen/vy-train-map";
import { getBackendUrl } from "api/common";
import { queryFnGET } from "api/tanStackQuery/helpers";
import { TrainCompositionResponse } from "features/CenterContent/VehicleDetails/TrainDetails/TrainComposition/types";

const trainCompositionQueryKey = (
  countryCode?: CountryCode,
  trainId?: string,
  nominalDate?: string,
) => [["trainComposition", countryCode, nominalDate, trainId]];

export function useTrainComposition({
  countryCode,
  identifier,
  nominalDate,
}: Partial<TrainIdentifier>) {
  // TODO: Workaround for now, until traincompo lets us fetch by actual identifier
  const coreTrainIdentifier =
    countryCode === "SE" ? identifier?.split("-").at(-1) : identifier;

  return useQuery({
    queryKey: trainCompositionQueryKey(
      countryCode,
      coreTrainIdentifier,
      nominalDate,
    ),
    refetchOnWindowFocus: true,
    queryFn: ({ signal }) =>
      queryFnGET<TrainCompositionResponse>({
        signal,
        url: `${getBackendUrl()}/trainComposition/${countryCode}/${nominalDate}/${coreTrainIdentifier}`,
      }),
    enabled: Boolean(countryCode && coreTrainIdentifier && nominalDate),
  });
}
